<div class="c-modal c-modal--md">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p">
					<p class="c-modal__title c-text c-text--xl">{{ 'Chats.Other.Download_Chat_History_Title' | translate }}</p>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="closeButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<br>
		<div class="c-modal__content">
			<p class="c-text">{{ 'Chats.Other.Download_Chat_History_Guide' | translate }}</p>
			<br>
		</div>
		<div class="c-modal__footer">
			<div class="o-grid">
				<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-p">
					<a id="download1" class="c-button c-button--s1" [href]="vm.downoadLink1">{{ 'Chats.Other.Download_Chat_With_Times_Button' | translate}}</a>
					&nbsp;
					<a id="download2" class="c-button c-button--s1" [href]="vm.downoadLink2">{{ 'Chats.Other.Download_Chat_Without_Times_Button' | translate}}</a>
				</div>
			</div>
		</div>
	</div>
</div>
